import React, { Fragment } from 'react';
import { candidateProfileStore } from '../CandidateProfileStore';
import { Loader } from '../../../components/layout/misc/Loader';
import { candidatesStore } from '../CandidatesStore';
import { CandidateProfileExpectationsEdit } from './CandidateProfileExpectationsEdit';
import { observer } from 'mobx-react';

@observer
export class CandidateProfileExpectationsMainPage extends React.Component {
	componentDidMount() {
		this.loadCandidate();
	}

	componentWillUnmount() {
		candidateProfileStore.reset();
	}

	async loadCandidate() {
		const result = await candidatesStore.get();
		candidateProfileStore.setCandidate(result.data);
	}
	render() {
		if (candidateProfileStore.candidate) {
			return (
				<Fragment>
					<div className="main-page">
						<CandidateProfileExpectationsEdit
							candidate={candidateProfileStore.candidate}
							handleSuccess={() => {
								candidateProfileStore.reloadCandidate();
							}}
						/>
					</div>
				</Fragment>
			);
		} else {
			return <Loader type="page-loader" />;
		}
	}
}
